import { request } from './client';

export const apiSubmitContact = (data) =>
  request('/contact', { method: 'POST', body: data });
